import { Component, effect, input,model } from '@angular/core';
import { NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-rating',
    imports: [NgbRatingModule],
    templateUrl: './rating.component.html',
    styleUrl: './rating.component.css'
})
export class RatingComponent {
  rating = model<number>(0);
  isRatingReadonly = input<boolean>(true);
  rate = 0;

	ariaValueText(current: number, max: number) {
		return `${current} out of ${max} hearts`;
	}
  constructor(){
  effect(() => {
    this.rate = this.rating();
  });
  }

  onRateChange(event){
    this.rating.set(event);
  }
}
